import React, { Dispatch } from 'react'
import { Button, FormControlLabel, MenuItem, Switch, TextField } from '@mui/material'
import { useNest } from 'hooks/api/useNest'
import { CreativeImportAction, CreativeImportState } from '../state'

interface Props {
  state: CreativeImportState
  dispatch: Dispatch<CreativeImportAction>
  onContinue: () => void
}

export const OptionsStep = ({ state, dispatch, onContinue }: Props) => {
  const { list: sprints, isLoading } = useNest('sprints')
  const attachToSprint = state.sprintID !== null

  const selectedCount = Object.values(state.rows).filter(row => row.selected).length

  return (
    <div className="flex flex-col gap-4">
      <p className="text-gray-700">
        {selectedCount} creative{selectedCount === 1 ? '' : 's'} will be imported as drafts.
      </p>

      <FormControlLabel
        control={
          <Switch
            checked={attachToSprint}
            onChange={e =>
              dispatch({
                type: 'setSprint',
                sprintID: e.target.checked ? sprints?.[0]?.id ?? null : null,
              })
            }
          />
        }
        label="Attach imported drafts to an existing sprint"
      />

      {attachToSprint && (
        <TextField
          select
          size="small"
          label="Sprint"
          value={state.sprintID ?? ''}
          disabled={isLoading}
          onChange={e => dispatch({ type: 'setSprint', sprintID: Number(e.target.value) })}
          className="max-w-sm"
        >
          {(sprints ?? []).map(sprint => (
            <MenuItem key={sprint.id} value={sprint.id}>
              {sprint.name}
            </MenuItem>
          ))}
        </TextField>
      )}

      <div className="flex justify-between">
        <Button onClick={() => dispatch({ type: 'backToReview' })}>Back</Button>
        <Button variant="contained" onClick={onContinue} disabled={selectedCount === 0}>
          Continue
        </Button>
      </div>
    </div>
  )
}
